import { render, staticRenderFns } from "./SiteAdmin.vue?vue&type=template&id=72b64e23&scoped=true"
import script from "./SiteAdmin.vue?vue&type=script&lang=js"
export * from "./SiteAdmin.vue?vue&type=script&lang=js"
import style0 from "./SiteAdmin.vue?vue&type=style&index=0&id=72b64e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b64e23",
  null
  
)

export default component.exports